import {
  SupervisionApi,
  SupervisionHistoryApi,
  SupervisionItemsApi,
  SupervisionChaptersApi,
  SupervisionCommentsApi,
} from "@socotec.io/ssp-back-sdk";
import { sspProjectConfig } from "@/setup/openApiConfig";

/**
 * Supervision Client
 * Exports configured SDK instances for use in the store
 */

// Export SDK instances
export const supervisionApi = new SupervisionApi(sspProjectConfig);
export const supervisionHistoryApi = new SupervisionHistoryApi(sspProjectConfig);
export const supervisionItemsApi = new SupervisionItemsApi(sspProjectConfig);
export const supervisionChaptersApi = new SupervisionChaptersApi(sspProjectConfig);
export const supervisionCommentsApi = new SupervisionCommentsApi(sspProjectConfig);
